<template></template>
<script>
export default {};
</script>
<style lang="scss">
@import "~normalize.css/normalize.css";
@import "~nprogress/nprogress.css";
@import "~bulma/sass/utilities/_all";

$block-spacing: 2;
$primary: #fc7234;
$primaryDark: #db5b20;

$link: #1d73f4;
$green: #9bc53d;
$orange: #ffdd57;
$red: #f14668;
$blue: #1d73f4;

$colors: (
  "info": (
    $blue,
    $info-invert,
  ),
  "success": (
    $green,
    $success-invert,
  ),
  "warning": (
    $orange,
    $warning-invert,
  ),
  "danger": (
    $red,
    $danger-invert,
  ),
  "primary": (
    $primary,
    $primary-invert,
  ),
);

@import "~bulma";
@import "~buefy/src/scss/buefy";
@import "../assets/scss/style.scss";

#nprogress .bar {
  background: #fc7234;
  height: 3px;
}

#nprogress .peg {
  box-shadow: 0 0 10px #fc7234, 0 0 5px #fc7234;
}

#nprogress .spinner-icon {
  border-top-color: #fc7234;
  border-left-color: #fc7234;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
}

#navbar {
  transition: all 0.2s ease;
}

#navbar.collapse {
  opacity: 0;
  max-height: 0;
  min-height: 0;
  height: 0;
  padding: 0 !important;
  .container {
    height: 0 !important;
    display: none;
  }
}

.suggestion-btn {
  position: fixed;
  bottom: 10px;
  left: 10px;
  button {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    &:hover {
      box-shadow: 0 4px 9px rgba(0, 0, 0, 0.25), 0 4px 4px rgba(0, 0, 0, 0.22);
    }
  }
}
</style>
